import React from 'react';

import Image from '@atlaskit/image';

import generativeIndicatorSvg from '../../../assets/generative-indicator.svg';

export interface GenerativeIndicatorProps {
	/** Test ID for the image element */
	testId?: string;
}

/**
 * GenerativeIndicator — A small colorful generative indicator icon used to
 * signal AI-generated or insights-related content.
 */
export const GenerativeIndicator = ({
	testId = 'generative-indicator',
}: GenerativeIndicatorProps): React.JSX.Element => {
	return <Image src={generativeIndicatorSvg} alt="" testId={testId} width={20} height={20} />;
};
